import { render, staticRenderFns } from "./edit_unit.vue?vue&type=template&id=35d31472&scoped=true"
import script from "./edit_unit.vue?vue&type=script&lang=js"
export * from "./edit_unit.vue?vue&type=script&lang=js"
import style0 from "./edit_unit.vue?vue&type=style&index=0&id=35d31472&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d31472",
  null
  
)

export default component.exports